import { SenderOptionBase } from "./sender-option-base";

export class EmailSenderOption extends SenderOptionBase {
  isGeneric: boolean;
  isOverrideFromPartner: boolean;
  from?: string;
  replyToList?: string[];
  cc?: string;
  bcc?: string;
}
